import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AccountService } from '../../services/account.service';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { Router } from '@angular/router';
import { WindowService } from '../../services/window.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {
  recaptcha: any;
  captchaError = false;
  loginEmail: string;
  logoPath: string;
  hostName: string;
  displayResetDialog = {
    success: false,
    fail: false,
  };
  private componentDestroyed = new Subject();
  constructor(
    private router: Router,
    private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private windowService: WindowService) {
    this.hostName = this.windowService.getHostName();
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.length > 0) {
        const region = this.windowService.getLogoRegion(res);
        if (typeof region !== 'undefined' && region !== null) {
          this.logoPath = region.Note;
        }
        // const logoPath = res.find(i => i.Region.toLowerCase() === this.hostName.toLowerCase()).Note;
        // if (typeof logoPath !== 'undefined' && logoPath !== null) {
        //   this.logoPath = logoPath;
        // }
      }
    });
  }

  ngOnInit() {
    this.ngxService.start();
    this.recaptcha = (window as any).grecaptcha;
    setTimeout(() => {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('body-login');
      body.classList.remove('body-landing');
      body.classList.remove('mobile-toggle');
      this.ngxService.stop();
    },500)
    
  }

  sendEmail(e) {
    this.ngxService.start();
    this.captchaError = !this.recaptcha.getResponse();
    if (e.valid && this.recaptcha.getResponse()) {
      this.apiService.ForgetPassword(e.value.loginEmail).subscribe(res => {
        this.ngxService.stop();
        // Reset password 成功和失敗提示
        setTimeout(() => {
          if (res.Flag === true) {
            this.displayResetDialog.success = true;
          } else {
            this.displayResetDialog.fail = true;
          }
        }, 500);
        // this.router.navigate(['/login']);
      });
    } else {
      this.ngxService.stop();
    }
  }

  closeDialog() {
    Object.keys(this.displayResetDialog).forEach(item => {
      if (this.displayResetDialog.success === true) {
        this.displayResetDialog[item] = false;
        this.router.navigate(['/login']);
      } else {
        this.displayResetDialog[item] = false;
        this.router.navigate(['/login']);
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
